import { render } from "./Smiley.vue?vue&type=template&id=7b0637db"
import script from "./Smiley.vue?vue&type=script&lang=js"
export * from "./Smiley.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__